/**
 * 将包含 @ 提及占位符的文本解析为渲染元素
 * 输入格式示例："感谢 @[Alice](user:u_alice) 的建议"
 * @param {string} content
 * @returns {Array<{type:'text'|'mention', text:string, userId?:string}>}
 */
export function parseCommentContentToElements(content) {
  const mentionRegex = /@\[([^\]]+)\]\(user:([^\)]+)\)/g
  const elements = []
  let lastIndex = 0
  let match
  while ((match = mentionRegex.exec(content)) !== null) {
    if (match.index > lastIndex) elements.push({ type: 'text', text: content.substring(lastIndex, match.index) })
    elements.push({ type: 'mention', text: `@${match[1]}`, userId: match[2] })
    lastIndex = match.index + match[0].length
  }
  if (lastIndex < content.length) elements.push({ type: 'text', text: content.substring(lastIndex) })
  return elements
}

/**
 * 根据文本与标签位置构造包含占位符的内容
 * 占位符格式：@[显示名](user:用户ID)
 * @param {string} inputText
 * @param {Array<{start:number,end:number,user_id:string,name:string}>} tags
 * @returns {{content:string, mentions:Array<{user_id:string,display:string,start:number,end:number}>}}
 */
export function buildContentWithMentions(inputText, tags) {
  const sorted = [...(tags || [])].sort((a, b) => b.start - a.start)
  let content = inputText
  const mentions = []
  sorted.forEach((tag) => {
    const before = content.substring(0, tag.start)
    const after = content.substring(tag.end)
    const placeholder = `@[${tag.name}]\(user:${tag.user_id})`
    content = before + placeholder + after
    mentions.push({ user_id: tag.user_id, display: tag.name, start: tag.start, end: tag.end })
  })
  return { content, mentions }
}